module["exports"] = [
  "vägen",
  "gatan",
  "gränden",
  "gärdet",
  "allén"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_suffix.js
// module id = 1602
// module chunks = 0